module.exports = __webpack_public_path__ + "img/gssc-logo.fb7ffcdc.jpg";